import { callApp, isInApp } from './mUtil'

/**
 * APP API 封装类
 * 统一处理芒果TV APP内外的API调用
 */
export const AppApi = new Proxy({}, {
  get(target, property) {
    return function (...args) {
      if (!isInApp()) {
        callApp(window.location.href)
        return Promise.reject(new Error('不在APP内'))
      }
      return new Promise((resolve, reject) => {
        try {
          if (typeof window.MgtvApi[property] === 'function') {
            window.MgtvApi[property](...args)
            resolve()
          } else {
            reject(new Error(`MgtvApi.${property} 不存在`))
          }
        } catch (error) {
          reject(error)
        }
      })
    }
  }
})
